import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=59992078"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59992078')) {
      api.createRecord('59992078', component.options)
    } else {
      api.reload('59992078', component.options)
    }
    module.hot.accept("./Trash.vue?vue&type=template&id=59992078", function () {
      api.rerender('59992078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Trash.vue"
export default component.exports